/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClaimImageDTO } from './ClaimImageDTO';
import type { ClaimInvoiceDTO } from './ClaimInvoiceDTO';
import type { ClaimItemDTO } from './ClaimItemDTO';
import type { ClaimNoteDTO } from './ClaimNoteDTO';
import type { ClaimShopDTO } from './ClaimShopDTO';
export type GetClaimCentralDetailResponse = {
    claimId?: string;
    claimNo?: string;
    type?: GetClaimCentralDetailResponse.type;
    modeType?: GetClaimCentralDetailResponse.modeType;
    status?: GetClaimCentralDetailResponse.status;
    brand?: string;
    version?: string;
    imei?: string;
    serialNumber?: string;
    battery?: number;
    defect?: string;
    lockType?: GetClaimCentralDetailResponse.lockType;
    lockPassword?: string;
    hirePrice?: number;
    deliveryDate?: string;
    items?: Array<ClaimItemDTO>;
    images?: Array<ClaimImageDTO>;
    notes?: Array<ClaimNoteDTO>;
    isSelfClaim?: boolean;
    shopsCentralClaim?: ClaimShopDTO;
    hireInvoices?: Array<ClaimInvoiceDTO>;
};
export namespace GetClaimCentralDetailResponse {
    export enum type {
        SELF = 'SELF',
        RECEIVE_CENTRAL = 'RECEIVE_CENTRAL',
        SEND_CENTRAL = 'SEND_CENTRAL',
    }
    export enum modeType {
        NONE = 'NONE',
        WAIT_SELECTION = 'WAIT_SELECTION',
        WAIT_APPROVAL = 'WAIT_APPROVAL',
        APPROVED = 'APPROVED',
        NOT_APPROVED = 'NOT_APPROVED',
    }
    export enum status {
        NONE = 'NONE',
        RECEIVE = 'RECEIVE',
        ORDER_SPARE = 'ORDER_SPARE',
        RECEIVE_SPARE = 'RECEIVE_SPARE',
        REPAIRING = 'REPAIRING',
        TESTING = 'TESTING',
        REPAIR_SUCCESS = 'REPAIR_SUCCESS',
        REPAIR_FAIL = 'REPAIR_FAIL',
        CANCEL = 'CANCEL',
    }
    export enum lockType {
        NONE = 'NONE',
        PIN = 'PIN',
        PASSWORD = 'PASSWORD',
        PATTERN = 'PATTERN',
    }
}

